import ArrowUpRightIcon from "@redotech/redo-icons/arrow-up-right_filled.svg";
import { cn } from "../../tailwind-utils";
import { Text } from "../../text";
import { TextSizeValue, TextWeightValue } from "../../theme/typography";
import * as containerCss from "./redo-external-link.module.css";

export function RedoExternalLink({
  url,
  text,
  showIcon = true,
  fontSize = "xs",
  fontWeight = "regular",
  textClassName,
  anchorClassName,
  uiSelector,
}: {
  url?: string | undefined;
  text?: string;
  fontSize?: TextSizeValue;
  showIcon?: boolean;
  newTab?: boolean;
  eyeIcon?: boolean;
  fontWeight?: TextWeightValue;
  textClassName?: string;
  anchorClassName?: string;
  uiSelector?: string;
}) {
  return (
    <a
      className={cn(containerCss.container, anchorClassName)}
      data-arbiter="RedoExternalLink"
      data-ui={uiSelector}
      href={url}
      rel="noreferrer"
      target="_blank"
    >
      <Text
        as="span"
        className={textClassName || containerCss.text}
        fontSize={fontSize}
        fontWeight={fontWeight}
      >
        {text}
      </Text>
      {showIcon && <ArrowUpRightIcon className={containerCss.icon} />}
    </a>
  );
}
